import {categories} from './categories';
import {combineReducers} from 'helpers';
import {index} from './index';
import {progress} from './progress';
import {subs} from './subs';
import {templates} from './templates';
import {timers} from './timers';

export const activities = combineReducers({index, progress, categories, subs, timers, templates});
